import { motion } from "framer-motion";
import { ArrowDown } from "lucide-react";

const HERO_IMG =
  "https://customer-assets.emergentagent.com/job_wedding-wheels-sk/artifacts/3zqikt5u_IMG_2734.jpeg";

export default function Hero() {
  return (
    <section
      id="uvod"
      data-testid="hero-section"
      className="relative min-h-[100vh] w-full overflow-hidden grain"
    >
      {/* Background */}
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{ backgroundImage: `url(${HERO_IMG})` }}
      />
      <div className="absolute inset-0 bg-gradient-to-t from-black via-black/55 to-black/30" />
      <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-transparent to-transparent" />

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-6 sm:px-12 min-h-[100vh] flex flex-col justify-end pb-24 pt-32">
        <motion.span
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 0.2 }}
          className="ornament mb-8"
        >
          Est. tradícia · ročník 1962
        </motion.span>

        <motion.h1
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, delay: 0.35, ease: [0.22, 1, 0.36, 1] }}
          className="font-serif font-light text-5xl sm:text-7xl lg:text-8xl tracking-tight leading-[0.95] text-cream max-w-4xl"
        >
          Legenda
          <br />
          <em className="text-gold not-italic font-serif italic font-light">na kolesách</em>
          <br />
          pre váš veľký deň.
        </motion.h1>

        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.6 }}
          className="mt-10 max-w-xl text-cream/70 text-lg leading-relaxed font-light"
        >
          Historická Tatra 603 — ikona československého dizajnu šesťdesiatych rokov.
          Prenajímame ju exkluzívne na svadby, oslavy a nezabudnuteľné okamihy.
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.8 }}
          className="mt-12 flex flex-wrap items-center gap-4"
        >
          <a href="#kontakt" data-testid="hero-cta-primary" className="btn-gold">
            Vyžiadať termín
          </a>
          <a href="#o-nas" data-testid="hero-cta-secondary" className="btn-ghost">
            Spoznať príbeh
          </a>
        </motion.div>

        <motion.a
          href="#o-nas"
          aria-label="Posunúť nadol"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1, delay: 1.2 }}
          className="hidden md:flex absolute right-12 bottom-12 flex-col items-center gap-3 text-cream/50 hover:text-gold transition-colors"
        >
          <span className="text-[10px] uppercase tracking-[0.35em] [writing-mode:vertical-rl]">
            Scroll
          </span>
          <ArrowDown size={16} className="animate-bounce" />
        </motion.a>
      </div>
    </section>
  );
}
